import Teams from '../TeamsEnum';
import DatePicker from "react-datepicker";
import React, { useState } from 'react';

const Torneos = {
  LIGA_PROFESIONAL: "Liga Profesional Argentina",
  COPA_ARGENTINA: "Copa Argentina",
  COPA_SUDAMERICANA: "Copa Sudamericana",
  COPA_LIBERTADORES: "Copa Libertadores",
};

const NextAwayMatchForm = ({ formDataNextAwayMatch, onInputChange, onSubmit }) => {
  const [startDate, setStartDate] = useState(new Date());

  const handleChange = (date) => {
    setStartDate(date);
    const formattedDate = date.toLocaleDateString('en-GB');
    onInputChange({
      target: { name: 'date', value: formattedDate }
    });
  };

  const isFormValid = () => {
    const requiredFields = [
      'vsTeam',
      'date',
      'matchHours',
      'placeName',
      'placeAddress',
      'torneo',
    ];
    return requiredFields.every((field) => formDataNextAwayMatch[field]?.trim());
  };

  return (
    <form onSubmit={onSubmit}>

      <div className="mb-3 mt-3">
        <label htmlFor="torneo" className="form-label">
          Torneo
        </label>
        <select
          className="form-control"
          id="torneo"
          name="torneo"
          onChange={onInputChange}
          value={formDataNextAwayMatch.torneo}>
          <option value="" disabled>Seleccionar torneo</option>
          {Object.entries(Torneos).map(([key, value]) => (
            <option key={key} value={value}>{value}</option>
          ))}
        </select>
      </div>

      <div className="mb-3 mt-3">
        <label htmlFor="vsTeam" className="form-label">
          Versus
        </label>
        <select
          className="form-control"
          id="vsTeam"
          name="vsTeam"
          onChange={onInputChange}
          value={formDataNextAwayMatch.vsTeam}>
          <option value="" disabled>Seleccionar equipo</option>
          {Object.entries(Teams).map(([key, value]) => (
            <option key={key} value={value}>{value}</option>
          ))}
        </select>
      </div>

      <div className="mb-3 mt-3">
        <label htmlFor="date" className="form-label">
          Fecha
        </label>
        <DatePicker
          selected={startDate}
          onChange={handleChange}
          className="form-control"
          id="date"
          name="date"
          dateFormat="dd-MM-yyyy"
        />
      </div>

      <div className="mb-3">
        <label htmlFor="matchHours" className="form-label">
          Hora Partido
        </label>
        <input
          type="time"
          className="form-control"
          id="matchHours"
          name="matchHours"
          onChange={onInputChange}
          value={formDataNextAwayMatch.matchHours}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="placeName" className="form-label">
          Lugar (nombre)
        </label>
        <input
          type="text"
          className="form-control"
          id="placeName"
          name="placeName"
          placeholder="Ej: Sede Peña Roja La Plata"
          onChange={onInputChange}
          value={formDataNextAwayMatch.placeName}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="placeAddress" className="form-label">
          Lugar (dirección)
        </label>
        <input
          type="text"
          className="form-control"
          id="placeAddress"
          name="placeAddress"
          placeholder="Ej: Calle 7 nº 1234, La Plata"
          onChange={onInputChange}
          value={formDataNextAwayMatch.placeAddress}
        />
      </div>

      <button
        type="submit"
        style={{
          backgroundColor: '#C73B33',
          borderColor: '#FF5733',
          color: '#FFF',
        }}
        className="btn"
        disabled={!isFormValid()}>
        Crear Próximo Partido de Visitante
      </button>

    </form>
  );
};

export default NextAwayMatchForm;
